export function pinTypes(state) {
    var pinTypes = state.pinTypes

    pinTypes = pinTypes.sort((a, b) => {
        let fa = a.name.toLowerCase(),
            fb = b.name.toLowerCase();

        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    });

    return pinTypes
}